import { PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "@/entities/users/types";
import { DealerSliceState } from "../types";

export const usersReducers = {
  sortDealerUserList: (
    state: DealerSliceState,
    action: PayloadAction<{
      field: keyof IUser | string | null;
      type: string | null;
    }>,
  ) => {
    const nameSort = action.payload.field as keyof IUser | null;
    const typeSort = action.payload.type;
    if (nameSort && typeSort !== null && state.currentDealerUsers.length > 1) {
      state.currentDealerUsers = state.currentDealerUsers.sort(
        (user1, user2): number => {
          if (typeSort === "asc") {
            return user1[nameSort]! > user2[nameSort]! ? 1 : -1;
          } else if (typeSort === "desc") {
            return user1[nameSort]! < user2[nameSort]! ? 1 : -1;
          } else {
            return 0;
          }
        },
      );
    }
  },
  searchDealerUser: (
    state: DealerSliceState,
    action: PayloadAction<string>,
  ) => {
    if (action.payload) {
      state.currentDealerUsers = state.currentDealerUsersForFilter.filter(
        (user) => {
          if (!user.fio) return true;
          if (
            user.fio &&
            user.fio.toLowerCase().indexOf(action.payload.toLowerCase()) >= 0
          ) {
            return true;
          } else {
            return false;
          }
        },
      );
    } else {
      state.currentDealerUsers = state.currentDealerUsersForFilter;
    }
  },
};
